<div id="header">
  <app-header></app-header>
</div>

<div class="d-flex align-items-stretch">
  <app-side-nav>
  </app-side-nav>
<router-outlet></router-outlet>
</div>
